import { axiosPost, axiosPut } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import setFormValidationError from 'shared/utils/setFormValidationError'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  id: string | undefined
  setError: Function
  extraData: any
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false

  const formats = props.data.formats instanceof Array ? props.data.formats.map((c) => c.id) : []
  delete props.data.formats

  const formData = {
    ...props.data,
    ais_id: props.data.ais_report?.id ?? null,
    vslz_id: props.data.vslz_report?.id,
    vslz_query_name: props.data.vslz_report?.name,
    height: props.data.height?.id,
  }

  const saveFormats = (responseData: any) => {
    const reportId = responseData?.data?.id
    const payload = {
      report_id: reportId,
      formats: formats,
    }
    return axiosPut(apiUrls.reportsToFormats + '/' + apiUrls.actionSave, payload, () => {
      return false
    })
  }

  const catchFunc = (err: AxiosError) => {
    if (err.response!.status === 422) {
      const mappedAttributes: Map<string, string> = new Map()
      mappedAttributes.set('ais_id', 'ais_report')
      mappedAttributes.set('vslz_id', 'vslz_report')
      mappedAttributes.set('vslz_query_name', 'vslz_report')
      mappedAttributes.set('description', 'description')
      mappedAttributes.set('height', 'height')
      setFormValidationError(err, props.setError, mappedAttributes, 'name')
    } else {
      displayGenError({ setShowOverlay: props.setShowOverlay })
    }
  }

  if (props.id === undefined) {
    const filterIds: Array<number> = props.extraData.filters.map((f) => f.filter_id)
    response = await axiosPost(apiUrls.reports, formData, catchFunc)
      .then((res) => {
        return res === undefined ? false : saveFormats(res)
      })
      .then((data) => {
        filterIds.forEach((filterId) => {
          axiosPost(
            apiUrls.filtersToReports,
            {
              filter_id: filterId,
              report_id: data.data.id,
            },
            catchFunc,
          )
        })
        return data
      })
  } else {
    response = await axiosPut(apiUrls.reports + '/' + props.id, formData, catchFunc).then((res) => {
      return res === undefined ? false : saveFormats(res)
    })
  }
  return response
}

export default submitForm
